import {useState} from "react"
import {trpc} from "@/lib/requests/index"
import CancelSubscriptionIcon from "@material-ui/icons/EventBusy"
import CreditCardIcon from "@material-ui/icons/CreditCard"
import AppLayout from "@/components/AppLayout"
import LoginLoader from "@/components/LoginLoader"

const DEACTIVATION_REDIRECT_URL = "https://pipelineprotools.com/account-cancellation/"

export default function Billing(): JSX.Element {
  
    const signOnRes = trpc.useQuery(
      ["billing.createSingleSignIn"], {enabled: false}
    )
    const billingQuery = trpc.useQuery(["billing.userStatus"])

    const [deactivatingAccount] = useState(false)

    async function deactivateAccount() {
      window.location.href = DEACTIVATION_REDIRECT_URL
      /*
      NOTE: for the time being deactivation will only
      redirect to the pipelineprotools deactivation
      page and not manually deactive the billing from
      the backend. In the future this may change which
      is why I've kept this code here, but commented out.
      
      if (!window.confirm("Are you sure you want to cancel your account?")) {
        return
      }
      setDeactivatingAccount(true)
      const res = await deactivateMutation.mutateAsync()
      setDeactivatingAccount(false)
      const code = res
      if (code !== DEACTIVATION_SUCCESSFUL) {
        window.alert(`A problem occurred when canceling account! Please contact support to resolve this issue (${SUPPORT_EMAIL}).`)
        return
      }
      router.push("/")
      window.setTimeout(() => {
        window.alert("Your account has been successfully deactivated. Contact support if you ever wish to reactivate.")
      }, 300)
      */
    }

    const loading = billingQuery.isLoading
    const error = billingQuery.isError
    const billingInitialized = billingQuery.data?.hasBeenInitialized || false
    const billingIsOutdated = billingQuery.data?.billingOutdated ?? true

    // disable button is always active now, as it simply
    // redirects to a help page
    const disableCancel = (
      false
      //!billingInitialized
      //|| billingIsOutdated
      //|| deactivatingAccount
    )

    return <AppLayout requiredAuth="user">
      {loading ? (
        <div className="w-full h-full flex items-center flex-col justify-center">
          <LoginLoader/>
        </div>
      ) : null}
      {error ? (
        <pre>{"Error: "}{billingQuery.error}</pre>
      ) : null}

      {billingQuery.data ? <section 
        id="billing" 
        className="w-full flex flex-col items-center"
      >
          
          <h1 className="text-2xl sm:text-4xl font-display mt-8">
            {"Billing"}
          </h1>
          <div className="box-content mt-8 p-4 w-3/4 sm:w-1/2">
            {!billingInitialized || billingIsOutdated ? <span 
              className="text-center text-yellow-400"
            >
              {"Your billing informattion is currently out of date, please email support (support@guerillarealty.com) to address this issue."}
            </span> : <span className="text-center">
              {"Welcome to the new billing portal! Please email contact support if you need assistance."}
            </span>}
            

            <div className="w-full flex mt-4">
              <div className="w-1/2">
                <div>
                  <button
                    className="hover:text-blue-500" 
                    disabled={
                      !billingInitialized
                      || billingIsOutdated
                    }
                    onClick={async () => {
                      const res = await signOnRes.refetch()
                      if (!res.data?.ok) {
                        window.alert("An unknown error occurred!")
                        return
                      }
                      window.open(res.data.url, "_blank", "noopener")
                    }}
                  >
                    <CreditCardIcon className="mr-2 mb-1 text-blue-500"/>
                    {
                      signOnRes.isLoading 
                      ? "Loading..."
                      : signOnRes.isError
                      ? "Error Occurred..."
                      : "View Billing Info"
                    }
                  </button>
                </div>

                <div className="mt-1">
                  <button
                    className="hover:text-red-500" 
                    disabled={disableCancel}
                    onClick={deactivateAccount}
                  >
                    <CancelSubscriptionIcon className="mr-2 mb-1 text-red-500"/>
                    {!deactivatingAccount 
                      ? "Cancel Account" 
                      : <span className="animate-pulse text-gray-400">{"Loading..."}</span>
                    }
                  </button>
                </div>
              </div>
            </div>
            </div>
        </section> : null}
  </AppLayout>
}